import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	HStack,
	Button,
} from '@chakra-ui/react'
import { InputText, Form } from '../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../helpers';




function Create({ meCloseEdit, loadList, rs, balance }) {


	const [formData, setFormData] = useState({});

	useEffect(() => {
		setFormData({
			balance: balance || 0,
			customer_id: rs?.id,
			businees_name: rs?.business_name
		})
	}, [])

	const FormSchema = Yup.object().shape({

		balance: Yup.string().required('Required'),


	});

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values


		const url = `${process.env.REACT_APP_API_URL}/transaction/add-balance`;
		await fetchWrapper.post(url, data)
		loadList()
		meCloseEdit();
		toast(`Record has been updated `, {
			type: "info"
		});
	}

	return (
		

			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>

				<HStack w="100%" >
					<Box w="70%">
						<InputText name="businees_name" title="Business" placeholder="" inputProps={{ disabled: true, required: true }} />
					</Box>

				</HStack>
				<HStack w="100%" >
					<Box w="70%">
						<InputText name="balance" title="Balance" placeholder="Please Enter Amount" inputProps={{ isRequired: true }} />
					</Box>

				</HStack>




				<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
					mb={4}

					type='submit'
				>
					Add Balance
				</Button>
			</Form>

	
	)
}

export default Create;

